module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_pdf_x32-8afa8.png";